import { connect } from 'react-redux'
import { NavigationMenuComponent } from './NavigationMenuComponent'
import { Dispatch } from 'redux'
import { fetchMenuData } from 'shared/store/menu'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => {
    const { menuItems } = state.menuPageState
    const leftItems = menuItems && menuItems.filter(e => e.position === 'LEFT')
    const rightItems =
        menuItems && menuItems.filter(e => e.position === 'RIGHT')
    return {
        ...state.menuPageState,
        leftItems,
        rightItems
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchPageData: () => d(fetchMenuData())
})

const NavigationMenu = connect(
    mapStateToProps,
    mapDispatchToProps
)(NavigationMenuComponent)

export { NavigationMenu }
